import { BigNumber, utils } from 'ethers';

import { DEFAULT_BIGNUM } from '@context/constants';

/**
 * Mirrors FarmsConnectedView `InvestmentInfo` / ExpiredFarm:
 * `farmExpiry = new Date(parseFloat(formatUnits(periodFinished, 0)) * 1000)` then `farmExpiry < now`.
 * Used for list APY so it stays consistent with the individual farm page.
 */
export function isFarmRewardsPeriodEnded(
  periodFinished: BigNumber | undefined,
): boolean {
  const raw = periodFinished ?? DEFAULT_BIGNUM;
  const ms = parseFloat(utils.formatUnits(raw, 0)) * 1000;
  if (!Number.isFinite(ms)) {
    return false;
  }
  return ms < Date.now();
}
